// Heavily inspired by https://github.com/CardJs/CardJs

/* eslint no-plusplus: 0 */
/* eslint no-confusing-arrow: 0 */
/* eslint no-nested-ternary: 0 */

const KEYS = {
  0: 48,
  9: 57,
  NUMPAD_0: 96,
  NUMPAD_9: 105,
  DELETE: 46,
  BACKSPACE: 8,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  SPACE: 32,
  HOME: 36,
  END: 35,
  TAB: 9,
  A: 65,
  X: 88,
  C: 67,
  V: 86,
}

const keyCodeFromEvent = e => e.which || e.keyCode
const keyIsCommandFromEvent = e => e.ctrlKey || e.metaKey
const keyIsNumber = e => keyIsTopNumber(e) || keyIsKeypadNumber(e)

const keyIsTopNumber = (e) => {
  const keyCode = keyCodeFromEvent(e)
  return keyCode >= KEYS[0] && keyCode <= KEYS[9]
}

const keyIsKeypadNumber = (e) => {
  const keyCode = keyCodeFromEvent(e)
  return keyCode >= KEYS.NUMPAD_0 && keyCode <= KEYS.NUMPAD_9
}

const keyIsDelete = e => keyCodeFromEvent(e) === KEYS.DELETE
const keyIsBackspace = e => keyCodeFromEvent(e) === KEYS.BACKSPACE
const keyIsSpace = e => keyCodeFromEvent(e) === KEYS.SPACE
const keyIsDeletion = e => keyIsDelete(e) || keyIsBackspace(e)

const keyIsArrow = (e) => {
  const keyCode = keyCodeFromEvent(e)
  return keyCode >= KEYS.ARROW_LEFT && keyCode <= KEYS.ARROW_DOWN
}

const keyIsNavigation = (e) => {
  const keyCode = keyCodeFromEvent(e)
  return keyCode === KEYS.HOME || keyCode === KEYS.END
}

const keyIsKeyboardCommand = (e) => {
  const keyCode = keyCodeFromEvent(e)
  return keyIsCommandFromEvent(e) && (keyCode === KEYS.A || keyCode === KEYS.X || keyCode === KEYS.C || keyCode === KEYS.V)
}

const keyIsTab = e => keyCodeFromEvent(e) === KEYS.TAB

const setCaretPosition = (element, caretPos) => {
  if (element != null) {
    if (element.createTextRange) {
      const range = element.createTextRange()
      range.move('character', caretPos)
      range.select()
    } else if (element.selectionStart) {
      element.focus()
      element.setSelectionRange(caretPos, caretPos)
    } else {
      element.focus()
    }
  }
}

const normalizeCaretPosition = (mask, caretPosition) => {
  let numberPos = 0
  if (caretPosition < 0 || caretPosition > mask.length) return 0

  for (let i = 0; i < mask.length; i++) {
    if (i === caretPosition) return numberPos
    if (mask[i] === 'X') numberPos++
  }
  return numberPos
}

const denormalizeCaretPosition = (mask, caretPosition) => {
  let numberPos = 0
  if (caretPosition < 0 || caretPosition > mask.length) return 0

  for (let i = 0; i < mask.length; i++) {
    if (numberPos === caretPosition) return i
    if (mask[i] === 'X') numberPos++
  }

  return mask.length
}

const numbersOnlyString = (string) => {
  let numOnlyString = ''
  for (let i = 0; i < string.length; i++) {
    const currentChar = string.charAt(i)
    const isValid = !isNaN(parseInt(currentChar, 10))
    if (isValid) (numOnlyString += currentChar)
  }
  return numOnlyString
}

const applyFormatMask = (string, mask) => {
  let formattedString = ''
  let numberPos = 0

  for (let j = 0; j < mask.length; j++) {
    const currentMaskChar = mask[j]
    if (currentMaskChar === 'X') {
      const digit = string.charAt(numberPos)
      if (!digit) break
      formattedString += string.charAt(numberPos)
      numberPos++
    } else {
      formattedString += currentMaskChar
    }
  }
  return formattedString
}

const filterNumberOnlyKey = (e) => {
  const isNumber = keyIsNumber(e)
  const isDeletion = keyIsDeletion(e)
  const isArrow = keyIsArrow(e)
  const isNavigation = keyIsNavigation(e)
  const isKeyboardCommand = keyIsKeyboardCommand(e)
  const isTab = keyIsTab(e)
  // preventDefault if any of these are true
  if (isNumber || isDeletion || isArrow || isNavigation || isKeyboardCommand || isTab) e.preventDefault()
}

class CursorUtils {
  static handleMaskedNumberInputKey(e, mask) {
    filterNumberOnlyKey(e)
    const keyCode = e.which || e.keyCode
    const element = e.target
    const caretStart = CursorUtils.caretStartPosition(element)
    const caretEnd = CursorUtils.caretEndPosition(element)
    const normalisedStartCaretPosition = normalizeCaretPosition(mask, caretStart)
    const normalisedEndCaretPosition = normalizeCaretPosition(mask, caretEnd)
    const isNumber = keyIsNumber(e)
    const isDelete = keyIsDelete(e)
    const isBackspace = keyIsBackspace(e)
    const isSpace = keyIsSpace(e)
    let newCaretPosition = caretStart

    if (isNumber || isDelete || isBackspace || isSpace) {
      e.preventDefault()
      const rawText = element.value
      let numbersOnly = numbersOnlyString(rawText)
      const digit = CursorUtils.digitFromKeyCode(keyCode)
      const rangeHighlighted = normalisedEndCaretPosition > normalisedStartCaretPosition

      // If there is a range of numbers highlighted
      if (rangeHighlighted) {
        numbersOnly = numbersOnly.slice(0, normalisedStartCaretPosition) + numbersOnly.slice(normalisedEndCaretPosition)
      }

      // Forward Action
      // eslint-disable-next-line eqeqeq
      if (caretStart != mask.length) {
        // Insert number digit
        if (isNumber && rawText.length <= mask.length) {
          numbersOnly = (numbersOnly.slice(0, normalisedStartCaretPosition) + digit + numbersOnly.slice(normalisedStartCaretPosition))
          newCaretPosition = Math.max(
            denormalizeCaretPosition(mask, normalisedStartCaretPosition + 1),
            denormalizeCaretPosition(mask, normalisedStartCaretPosition + 2) - 1
          )
        }

        // Delete
        if (isDelete) {
          numbersOnly = (numbersOnly.slice(0, normalisedStartCaretPosition) + numbersOnly.slice(normalisedStartCaretPosition + 1))
        }
      }

      // Backward Action
      // eslint-disable-next-line eqeqeq
      if (caretStart != 0) {
        // Backspace
        if (isBackspace && !rangeHighlighted) {
          numbersOnly = (numbersOnly.slice(0, normalisedStartCaretPosition - 1) + numbersOnly.slice(normalisedStartCaretPosition))
          newCaretPosition = denormalizeCaretPosition(mask, normalisedStartCaretPosition - 1)
        }
      }

      element.value = applyFormatMask(numbersOnly, mask)
      setCaretPosition(element, newCaretPosition)
    }
  }

  static digitFromKeyCode(keyCode) {
    return (keyCode >= KEYS[0] && keyCode <= KEYS[9]) ? keyCode - KEYS[0] :
      (keyCode >= KEYS.NUMPAD_0 && keyCode <= KEYS.NUMPAD_9) ? keyCode - KEYS.NUMPAD_0 : null
  }

  static caretStartPosition(element) { return (typeof element.selectionStart === 'number') ? element.selectionStart : !1 }
  static caretEndPosition(element) { return (typeof element.selectionEnd === 'number') ? element.selectionEnd : !1 }

  static afterEventValue(event) {
    const value = event.target.value
    const start = CursorUtils.caretStartPosition(event.target)
    const end = CursorUtils.caretEndPosition(event.target)
    const key = event.key
    const futureValue = value.slice(0, start) + key + value.slice(end + Math.abs(0))
    return futureValue
  }
}

export default CursorUtils
